__turbopack_context__.v({
  "root": "BaseSelect-module__okD-wa__root" + " " + __turbopack_context__.i(60951)["baseInput"],
});
